import axios, { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from 'react-query';
import {
  CreateTestimonialResponse,
  UpdateTestimonialResponse,
} from '~/types/api/testimonials';
import { Testimonial } from '~/types/models/testimonial';

export const testimonialApiPath = '/api/v3/testimonials';

export type CreateTestimonialPayload = {
  metadata?: Testimonial['metadata'];
};

export async function createTestimonial(payload: CreateTestimonialPayload) {
  const res = await axios.post<CreateTestimonialResponse>(
    `${testimonialApiPath}/`, 
    payload
  );
  return res.data;
}

export interface UseCreateTestimonialParams {
  options?: UseMutationOptions<CreateTestimonialResponse, AxiosError, CreateTestimonialPayload>;
}

export const useCreateTestimonial = (params?: UseCreateTestimonialParams) =>
  useMutation<CreateTestimonialResponse, AxiosError, CreateTestimonialPayload>(
    (payload: CreateTestimonialPayload) => createTestimonial(payload),
    params?.options
  );


interface UpdateTestimonialNameArgs {
  testimonialUuid: string;
  name: string;
}

export async function updateTestimonialName({
  testimonialUuid,
  name,
}: UpdateTestimonialNameArgs) {
  const res = await axios.post<UpdateTestimonialResponse>(
    `${testimonialApiPath}/${testimonialUuid}`,
    {
      _method: 'PUT',
      name,
    }
  );
  return res.data;
}
